import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { AbstractControl, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { BootstrapInterface, Conf } from 'src/app/conf';
import { CredentialsI} from '../../interfaces/user.interface';
import { Interaction } from 'src/app/interfaces/interaction.interface';
import { AppService } from 'src/app/services/app.service';
import { RouterParams } from 'src/app/services/router-params.service';
import { StorageService } from '../../services/storage.service';


@Component({
  selector: 'app-sign-in-page',
  templateUrl: './sign-in-page.component.html',
  styleUrls: ['./sign-in-page.component.scss']
})
export class SignInPageComponent {
  private uid: string;
  private clientId: string;
  private interaction: Interaction;
  private redirectTo: string;
  private credNotFound = false;
  private passwordFormSubscription: Subscription;
  private emailFormSubscription: Subscription;
  private credentials: CredentialsI = {
    email: null,
    password: null,
    uid: null
  };
  public loggedIn = false;
  public hidePW = true;

  public emailFormControl = new FormControl(this.credentials.email, [
    Validators.required,
    Validators.email,
    (c: AbstractControl) => {
      if (!this.credNotFound) {
        return null;
      } else {
        return {
          cred_found: {
            valid: false
          }
        };
      }
    }
  ]);

  public passwordFormControl = new FormControl(this.credentials.password, [
    Validators.required,
    (c: AbstractControl) => {
      if (!this.credNotFound) {
        return null;
      } else {
        return {
          cred_found: {
            valid: false
          }
        };
      }
    }
  ]);

  constructor(private app: AppService, private route: ActivatedRoute, private params: RouterParams, private storage: StorageService) {
    this.uid = this.credentials.uid = this.route.snapshot.paramMap.get('uid');
    this.clientId = this.route.snapshot.paramMap.get('clientId');
    this.redirectTo = this.params.get('redirectTo');


    if (this.uid) {
      this.app.getInteraction(this.uid).then((intreaction: Interaction) => {
        this.interaction = intreaction;
        if (this.interaction.payload.prompt.name === 'consent') {
          this.app.consent(this.uid).then((consent: boolean) => {
            if (consent) {
              window.location.href = this.interaction.payload.returnTo;
            }
          });
        }
      });
    } else {
      this.app.isAuthed((auth: boolean) => {
        if (auth) {
          if (this.clientId) {
            this.redirect2Client();
          } else if (this.redirectTo) {
            this.app.router.navigateByUrl(this.redirectTo);
          } else {
            this.app.router.navigateByUrl('willkommen');
          }
        }
      });
    }
  }

  public redirect2Client(): void {
    this.getRedirectUrl().then((data: { permission: boolean, url: string }) => {
      // console.log(data);
      if (data.permission && data.url) {
        window.location.href = data.url + this.app.getToken();
      } else {
        this.app.router.navigateByUrl('willkommen');
      }
    }).catch((e: Error) => {
      console.error(e);
    });
  }

  public async getRedirectUrl(): Promise<{ permission: boolean, url: string }> {
    let client: BootstrapInterface = null;
    if (this.clientId) {
      client = Conf.bootstrap[this.clientId];
    } else if (this.app.context !== 'sso') {
      client = Conf.bootstrap[this.app.context];
    }

    const permission = await this.hasRedirectPermission(client);
    const url = (client && client.redirectUrl && client.redirectUrl.login) ? client.redirectUrl.login : null;

    return {
      permission,
      url,
    }
  }

  private async redirectFromStorage() {
    const route = await this.storage.get('redirect-route');
    if(route) {
      console.log('rdfs', this.redirectTo);
      await this.storage.remove('redirect-route');
      this.app.router.navigateByUrl(route);
    }
  }

  public async hasRedirectPermission(client: BootstrapInterface): Promise<boolean> {
    if (client) {
      const prefixes = client.prefixes || null;
      let access = false;
      for await (const claim of await this.app.getClaims()) {
        const found = prefixes.find((prefix: string) => claim.name.includes(prefix));
        if (found) {
          access = true;
        }
      }
      return access;
    } else {
      return false;
    }
  }

  public onSubmit(): void {
    this.credentials.email = this.emailFormControl.value;
    this.emailFormControl.updateValueAndValidity();
    this.credentials.password = this.passwordFormControl.value;
    this.passwordFormControl.updateValueAndValidity();
    if (!this.passwordFormControl.errors && !this.emailFormControl.errors) {
      this.auth();
    }
  }

  protected async auth(): Promise<void> {
    this.app.auth(this.credentials).then((auth: boolean) => {
      this.loggedIn = true;

      this.redirectFromStorage();

      if (this.uid) {
        window.location.href = this.app.oidc.url + 'auth/' + this.uid;
      } else if (this.clientId) {
        this.redirect2Client();
      }
    }).catch((e: HttpErrorResponse) => {
      if (e.name === 'HttpErrorResponse') {
        if (e.status === 404) {
          this.credNotFound = true;
          this.emailFormControl.markAllAsTouched();
          this.emailFormControl.markAsDirty();
          this.emailFormControl.updateValueAndValidity();
          this.passwordFormControl.markAllAsTouched();
          this.passwordFormControl.markAsDirty();
          this.passwordFormControl.updateValueAndValidity();
          this.emailFormSubscription = this.emailFormControl.valueChanges.subscribe(() => {
            this.credNotFound = false;
            this.emailFormControl.markAsPristine();
            this.passwordFormControl.markAsPristine();
            this.emailFormSubscription.unsubscribe();
            this.passwordFormSubscription.unsubscribe();
          });
          this.passwordFormSubscription = this.passwordFormControl.valueChanges.subscribe(() => {
            this.credNotFound = false;
            this.passwordFormControl.markAsPristine();
            this.emailFormControl.markAsPristine();
            this.emailFormSubscription.unsubscribe();
            this.passwordFormSubscription.unsubscribe();
          });
        } else {
          this.app.toast.open('Unbekannter Fehler');
        }
      } else {
        this.app.toast.open('Unbekannter Fehler');
      }
    });
  }

}
